//@ts-check

class AuthenticationService {
	constructor($q, $http, $window, Utility, $timeout, $rootScope, LocalStorageService, InternalLinksService, $sce) {
		this.$q = $q;
		this.$http = $http;
		this.$window = $window;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;
		this.$sce = $sce;

		this.init();
	}

	init() {
		this.links = undefined;
		this._await = undefined;
		this.isAuthorized = false;
	}

	async registerUser(userDetails) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('RegisterUser');
			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('RegisterUser');
			}

			let results = await this.$http.post(url, userDetails);
			results = results.hasOwnProperty('data') ? results.data : results;

			const oldUserProfile = this.LocalStorageService.retrieve('userProfile');

			delete userDetails.Password;
			userDetails.FullName = userDetails.FirstName + ' ' + userDetails.LastName;

			//Potential Bug/Issue
			const updatedUserProfile = {
				...oldUserProfile,
				userDetails
			};

			this.LocalStorageService.save('userProfile', this._fixBDRefTrim(updatedUserProfile));
			this.$rootScope.$broadcast('user-profile-updated', updatedUserProfile);

			this.$timeout(() => promiseHandler.resolve(results));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async dontShowRegisterPrompt() {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const currentUserDetails = this.currentUser();
			if (!currentUserDetails) {
				throw new Error('No authenticated user found..');
			}

			let url = await this.InternalLinksService.getLink('ChangePromptFlag');
			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('ChangePromptFlag');
			}

			const payLoad = {
				ShowPrompt: false,
				ProfileId: currentUserDetails.ProfileId
			};

			const results = await this.$http.post(url, payLoad);
			if (results.WasSuccessful) {
				const oldUserProfile = this.LocalStorageService.retrieve('userProfile');
				oldUserProfile.ProfileReminder.ShowUserAuthenticationNotSecure = false;
				this.LocalStorageService.save('userProfile', this._fixBDRefTrim(oldUserProfile));

				this.$timeout(() => promiseHandler.resolve(results));
			} else {
				throw new Error(`Error while trying to update the 'Register Prompt'`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async loginUser(userName, password) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!userName) {
				throw new Error('No username found..');
			}
			if (!password) {
				throw new Error('No password found..');
			}

			let url = await this.InternalLinksService.getLink('UserLogin');
			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('UserLogin');
			}

			const payLoad = {
				UserName: userName,
				Password: password
			};

			this._notifyLoadingIndicator(true);
			let sessionResult = await this.$http.post(url, payLoad);

			sessionResult = sessionResult.hasOwnProperty('data') ? sessionResult.data : sessionResult;
			let profileResult = await this.requestProfile(sessionResult.SessionToken);

			profileResult = this._fixBDRefTrim(profileResult);
			await this.LocalStorageService.save('userSession', sessionResult);
			this.$rootScope.$broadcast('user-session-set', undefined);

			await this.LocalStorageService.save('userProfile', profileResult);

			const results = [sessionResult, profileResult];

			this._notifyLoadingIndicator(false);
			this.$rootScope.$broadcast('user-logged-in', results);

			this.$timeout(() => promiseHandler.resolve(results));
		} catch (err) {
			this._notifyLoadingIndicator(false, err);
			this.$timeout(() => promiseHandler.reject(err));
		}
		this._notifyLoadingIndicator(false);
		return promise;
	}

	async userForgotPassword(userName) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!userName) {
				throw new Error('No username found..');
			}

			let url = await this.InternalLinksService.getLink('ForgotPassword');
			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('ForgotPassword');
			}

			const payLoad = {
				UserName: userName
			};

			let results = await this.$http.post(url, payLoad);
			results = results.hasOwnProperty('data') ? results.data : results;

			if (results.WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve(results));
			} else {
				throw new Error(`Error while calling 'Reset Password'.`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async promptForNewPassword(token) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!token) {
				throw new Error('No reset password token found..');
			}

			this.LocalStorageService.delete('resetPasswordToken');
			this.$rootScope.$broadcast('show-reset-password-auth-modal', token);
			if (this.LocalStorageService.retrieve('resetPasswordToken')) {
				this.$timeout(() => promiseHandler.resolve('User was prompt for the new password'));
			} else {
				throw new Error(`'Reset Password Token' could not be saved.`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async userResetPassword(newPassword, resetToken) {

		let promise, promiseHandler;
		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!resetToken) {
				throw new Error('No reset password token found..');
			}

			if (!newPassword) {
				throw new Error('No new password provided..');
			}

			let url = this.InternalLinksService.getLink('ResetPassword');
			if (!url) {
				this.InternalLinksService.getLinks('links', true);
				url = this.InternalLinksService.getLink('ResetPassword');
			}

			const payLoad = {
				Token: resetToken,
				NewPassword: newPassword
			};
			let results = await this.$http.post(url, payLoad);

			results = results.hasOwnProperty('data') ? results.data : results;

			if (results.WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve(results));
			} else {
				throw new Error(`Error while 'Resetting User Password'.`);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async authorize(forceRefresh) {
		let results, promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			const urlAuthToken = this.Utility.QueryString('authtoken');
			const currentUser = this.currentUser();


			this._notifyLoadingIndicator(true);
			//console.log("forceRefresh: " + JSON.stringify(forceRefresh));
			if (forceRefresh) {
				const userProfile = this.LocalStorageService.retrieve('userProfile');
				results = await this.reAuthenticateUser(userProfile);
				this.$timeout(() => promiseHandler.resolve(results));
			} else if (urlAuthToken) {
				//console.log("urlAuthToken: " + JSON.stringify(urlAuthToken));
				results = await this.authenticateUserViaRest(urlAuthToken);
				//is.LocalStorageService.clearAll();
				this.$timeout(() => promiseHandler.resolve(results));
			} else if (currentUser) {
				//console.log("currentUser: " + JSON.stringify(currentUser));
				this.$timeout(() => promiseHandler.resolve(currentUser));
			}
		} catch (err) {
			const errMsg = `Error while tying to Authorize user`;
			console.error(errMsg, err);

			this._notifyLoadingIndicator(false, err);
			this.$timeout(() => promiseHandler.reject(err));
		} finally {
			const lastLoggedIn = moment().format('DD MMM YYYY HH:mm A');
			this.LocalStorageService.save('lastLoggedIn', lastLoggedIn);
			const userDetails = results ? results : this._fixBDRefTrim(results);
			const profile = userDetails && userDetails.length > 0 ? userDetails[1] : userDetails;
			this._notifyLoadingIndicator(false);
			//console.log("profile: " + JSON.stringify(profile));
			//console.log("userDetails: " + JSON.stringify(userDetails));

			this.$rootScope.$broadcast('user-logged-in-load-building-data', undefined);
			this.$rootScope.$broadcast('user-logged-in', userDetails);
		}

		return promise;
	}

	async authorizeClearanceToken(clearanceToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const results = await this.authenticateUserViaRestWithClearanceToken(clearanceToken);
			this.$timeout(() => promiseHandler.resolve(results));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}
	async authorizeRentalsToken(rentalsToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const results = await this.authenticateUserViaRestWithRentalsToken(rentalsToken);
			this.$timeout(() => promiseHandler.resolve(results));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async authorizeAuditsToken(auditsToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const results = await this.authenticateUserViaRestWithAuditsToken(auditsToken);
			this.$timeout(() => promiseHandler.resolve(results));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async authenticateUserViaRestWithAuditsToken(auditsToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const auditsResult = await this.authenticateByAuditsToken(auditsToken);
			if (!!auditsResult) {
				this.$timeout(() => promiseHandler.resolve(auditsResult));
			} else {
				throw new Error('Error, user with audits token: ' + auditsToken + ' could not be authenticated');
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async authenticateByAuditsToken(credentialToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('AuthenticateAuditsToken');

			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('AuthenticateAuditsToken');
			}

			url = url + '?token=' + credentialToken;
			const results = await this.$http.get(url);
			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			console.error('Error while authenticating user by token: ', err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}
	
	_fixBDRefTrim(userProfile) {
		if (userProfile && userProfile.BuildingProfiles && userProfile.BuildingProfiles.length) {
			const results = _.map(userProfile.BuildingProfiles, (building) => {
				building.SchemeReference = building.SchemeReference.trim();
				return building;
			});

			userProfile.BuildingProfiles = _.sortBy(results, (pb) => {
				return pb.SchemeName;
			});

			userProfile.BuildingProfiles = this.addBuildingImagesToArrayOfBuildingProfiles(userProfile.BuildingProfiles)
		}

		return userProfile;
	}

	addBuildingImagesToArrayOfBuildingProfiles(arrayOfBuildingProfiles) {

		if (!!!arrayOfBuildingProfiles || arrayOfBuildingProfiles.length == 0) {
			return;
		}

		const buildings = arrayOfBuildingProfiles;
		const mapped = buildings.map(building => {
			const { SchemeReference: schemeReference } = building;
			const imgUrl = this.getTrustedBuildingImageUrl(schemeReference);
			return {
				imgUrl,
				...building,
				isSelected: false
			};
		});

		return mapped;
	}

	getTrustedBuildingImageUrl(schemeReference) {
		const imgUrl = this.$sce.trustAsResourceUrl(
			`${PretorCDNAddress}/images/buildings/${schemeReference}/${schemeReference}.png`
		);
		const trustedUrl = this.$sce.valueOf(imgUrl);
		return trustedUrl;
	};

	/**
	 * Helper  with logic for authenticating user via the Authentication REST API by an auth => token
	 * @async
	 * @param {string} authToken The authentication token string
	 * @returns {Promise<Object[]>} The Promise of type Collection of results.
	 */
	async authenticateUserViaRest(authToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const sessionResult = await this.authenticateByToken(authToken);

			if (!!sessionResult && sessionResult.hasOwnProperty('SessionToken')) {
				let profileResult = await this.requestProfile(sessionResult.SessionToken);

				profileResult = this._fixBDRefTrim(profileResult);
				sessionResult.AuthToken = authToken;
				await this.LocalStorageService.save('userSession', sessionResult);
				this.$rootScope.$broadcast('user-session-set', undefined);

				await this.LocalStorageService.save('userProfile', profileResult);

				const results = [sessionResult, profileResult];
				this.$timeout(() => promiseHandler.resolve(results));
			} else {
				throw new Error('Error while authenticating with the provided token.');
			}
		} catch (error) {
			this.$timeout(() => promiseHandler.reject(error));
		}
		//this.$rootScope.$broadcast('user-logged-in-load-building-data', undefined);
		//this.$rootScope.$broadcast('user-logged-in', userDetails);
		return promise;
	}

	async authenticateUserViaRestWithClearanceToken(clearanceToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const clearanceResult = await this.authenticateByClearanceToken(clearanceToken);
			if (!!clearanceResult) {
				this.$timeout(() => promiseHandler.resolve(clearanceResult));
			} else {
				throw new Error('Error, user with clearance token: ' + clearanceToken + ' could not be authenticated');
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async authenticateUserViaRestWithRentalsToken(rentalsToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const rentalsResult = await this.authenticateByRentalsToken(rentalsToken);
			if (!!rentalsResult) {
				this.$timeout(() => promiseHandler.resolve(rentalsResult));
			} else {
				throw new Error('Error, user with rentals token: ' + rentalsToken + ' could not be authenticated');
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async reAuthenticateUser(userProfile) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let profileId = undefined;
			if (userProfile) {
				if (userProfile.hasOwnProperty('ProfileId')) {
					profileId = userProfile.ProfileId;
				} else if (userProfile.hasOwnProperty('WebProfileId')) {
					profileId = userProfile.WebProfileId;
				} else if (userProfile.hasOwnProperty('Id')) {
					profileId = userProfile.Id;
				}
			}

			let url = await this.InternalLinksService.getLink('CreateSessionByProfileId');

			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('CreateSessionByProfileId');
			}

			url = url.replace('{profileId}', profileId);

			if (profileId) {
				//call REST API Auth(CreateSessionByProfileId)
				let sessionResult = await this.$http.post(url);
				//Save the new user session
				sessionResult = sessionResult.data ? sessionResult.data : sessionResult;

				await this.LocalStorageService.save('userSession', sessionResult);
				this.$rootScope.$broadcast('user-session-set', undefined);


				//Call REST API Auth(GetProfileById)
				url = this.InternalLinksService.getLink('RequestProfile');
				url = url.replace('{tokenString}', sessionResult.SessionToken);
				let profileResults = await this.$http.get(url);
				//Save Profile
				profileResults = profileResults.data
					? this._fixBDRefTrim(profileResults.data)
					: this._fixBDRefTrim(profileResults);

				this.LocalStorageService.save('userProfile', profileResults);
				this.$timeout(() => promiseHandler.resolve([sessionResult, profileResults]));
			} else {
				throw new Error(`Could not get the user's profile ID`);
			}
		} catch (err) {
			this.LocalStorageService.clear();
			this.$window.location = '/';
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async requestProfile(tokenString) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('RequestProfile');

			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('RequestProfile');
			}

			url = url.replace('{tokenString}', tokenString);

			const headers = this._unauthenticatedHeader;

			const results = await this.$http.get(url, { headers });
			const profile = this._mapProfile(results.data);
			this.$timeout(() => promiseHandler.resolve(this._fixBDRefTrim(profile)));
		} catch (err) {
			console.error('Error while retrieving user session profile: ', err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	/**
	 * Mapped the raw profile from the server into an angular profile
	 * @param {object} profile Raw profile to be mapped
	 * @returns {object} mappedProfile The mapped profile
	 */
	_mapProfile(profile) {
		const Id = profile.WebProfileId;
		const UserName = profile.WebUsername || profile.UserName;

		const mappedProfile = {
			BuildingProfiles: profile.BuildingProfiles,
			CurrentPasswordCredentialId: profile.CurrentPasswordCredentialId,
			DateCreated: profile.DateCreated,
			IsActiveDirectoryUser: profile.IsActiveDirectoryUser,
			IsAnonymous: profile.IsAnonymous,
			ProfileReminder: profile.ProfileReminder,
			MasterProfileId: profile.MasterProfileId,
			FullName: profile.FullName,
			Id,
			UserName
		};

		return mappedProfile;
	}

	async authenticateByToken(credentialToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('AuthenticateByToken');

			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('AuthenticateByToken');
			}

			const headers = this._unauthenticatedHeader;
			url = url.replace('{credentialToken}', credentialToken);
			const results = await this.$http.get(url, { headers });
			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			console.error('Error while authenticating user by token: ', err);
			this.$timeout(() => promiseHandler.reject(err));
		}
		return promise;
	}

	async authenticateByClearanceToken(credentialToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('AuthenticateClearanceToken');

			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('AuthenticateClearanceToken');
			}

			url = url + '?token=' + credentialToken;
			const results = await this.$http.get(url);
			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			console.error('Error while authenticating user by token: ', err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async authenticateByRentalsToken(credentialToken) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('AuthenticateRentalsToken');

			if (!url) {
				await this.InternalLinksService.getLinks('links', true);
				url = await this.InternalLinksService.getLink('AuthenticateRentalsToken');
			}

			url = url + '?token=' + credentialToken;
			const results = await this.$http.get(url);
			this.$timeout(() => promiseHandler.resolve(results.data));
		} catch (err) {
			console.error('Error while authenticating user by token: ', err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	currentUser() {
		const currentUser = this.LocalStorageService.retrieve('userProfile');
		return currentUser;
	}

	logout() {
		this.LocalStorageService.clearAll();
		this.$rootScope.$broadcast('user-logged-out');
	}

	impersonateUser(userName) {
		const deferred = this.$q.defer();
		const promise = deferred.promise;

		//Possible Impersonation Error
		//const userName = this.Utility.QueryString('impersonateUser');

		let loadLinksPromise;
		let url = this.InternalLinksService.getLink('ImpersonateUser');

		if (!url) loadLinksPromise = this.InternalLinksService.getLinks('/api/accounts/links');
		else {
			const linksDeferred = this.$q.defer();
			loadLinksPromise = linksDeferred.promise;
			linksDeferred.resolve();
		}

		if (!userName) deferred.reject('No user name provided...');

		loadLinksPromise.then(() => {
			if (!url) url = this.InternalLinksService.getLink('ImpersonateUser');

			url = url.replace('{userName}', userName);

			this._notifyLoadingIndicator(true);
			this.$http.get(url).then(
				(results) => {
					const userAuthToken = results.hasOwnProperty('data') ? results.data : results;

					this.authenticateUserViaRest(userAuthToken).then(
						(results) => {
							this._notifyLoadingIndicator(false);
							const lastLoggedIn = moment().format('DD MMM YYYY HH:mm A');
							this.LocalStorageService.save('lastLoggedIn', lastLoggedIn);
							this.$rootScope.$broadcast('user-logged-in', results);
							deferred.resolve(results);
						},
						(err) => {
							this._notifyLoadingIndicator(false, err);
							deferred.reject(err);
						}
					);
				},
				(err) => {
					this._notifyLoadingIndicator(false, err);
					deferred.reject(err);
				}
			);
		});

		return promise;
	}

	schemeLogin(schemeReference) {
		const deferred = this.$q.defer();
		const promise = deferred.promise;

		let loadLinksPromise;
		let url = this.InternalLinksService.getLink('SchemeLogin');

		if (!url) loadLinksPromise = this.InternalLinksService.getLinks('/api/accounts/links');
		else {
			const linksDeferred = this.$q.defer();
			loadLinksPromise = linksDeferred.promise;
			linksDeferred.resolve();
		}

		if (!schemeReference) deferred.reject('No scheme ref name provided...');

		loadLinksPromise.then(() => {
			if (!url) url = this.InternalLinksService.getLink('SchemeLogin');

			url = url.replace('{schemeReference}', schemeReference);

			this._notifyLoadingIndicator(true);
			this.$http.get(url).then(
				(results) => {
					const userAuthToken = results.hasOwnProperty('data') ? results.data : results;

					this.authenticateUserViaRest(userAuthToken).then(
						(results) => {
							this._notifyLoadingIndicator(false);
							const lastLoggedIn = moment().format('DD MMM YYYY HH:mm A');
							this.LocalStorageService.save('lastLoggedIn', lastLoggedIn);
							this.$rootScope.$broadcast('user-logged-in', results);
							deferred.resolve(results);
						},
						(err) => {
							this._notifyLoadingIndicator(false, err);
							deferred.reject(err);
						}
					);
				},
				(err) => {
					this._notifyLoadingIndicator(false, err);
					deferred.reject(err);
				}
			);
		});

		return promise;
	}

	/**
	 * Checks if the current user has the specified role for the specified building
	 * @param {string} buildingRef The building reference
	 * @param {string} role The building role 
	 */
	hasRoleForBuilding(buildingRef, role) {
		const currentUser = this.currentUser();
		if (!currentUser) return false;

		const buildingProfiles = currentUser.BuildingProfiles;
		if (!buildingProfiles || buildingProfiles.length < 1) return false;

		const building = _.find(buildingProfiles, (buildingProfile) => {
			const rightBuilding =
				buildingProfile.SchemeReference.toUpperCase().trim() === buildingRef.toUpperCase().trim();

			return rightBuilding;
		});
		if (!building) return false;

		const buildingClaim = building.Role.find((claim) => {
			return claim.toUpperCase().trim() === role.toUpperCase().trim();
		});

		if (buildingClaim) return true;

		return false;
	}

	async unsubscribeMonthlyFinancialDocs() {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			const user = this.currentUser();
			if (!user) {
				throw new Error('No user found...');
			}

			let url = await this.InternalLinksService.getLink('OptOutMonthlyFinancialDocs');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/accounts/links');
				await this.InternalLinksService.getLink('OptOutMonthlyFinancialDocs');
			}

			url = url.replace('{userName}', user.UserName);
			let results = await this.$http.get(url);
			results = results.hasOwnProperty('data') ? results.data : results;

			if (results.WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve(results));
			} else {
				throw new Error(
					'Error while unsubscribing from the monthly financial emails:\n' + JSON.stringify(results.Errors)
				);
			}
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}
		return promise;
	}

	_notifyLoadingIndicator(isBusy, err) {
		this.$timeout(() => {
			this.$rootScope.$broadcast('user-login-busy', { isBusy, err });
		}, 1200);
	}

	get _headers() {
		return this.Utility.headersWithContentType;
	}

	get _unauthenticatedHeader() {
		return this.Utility.basicHeaders;
	}
}

export default /* @ngInject */ (
	$q,
	$http,
	$window,
	Utility,
	$timeout,
	$rootScope,
	LocalStorageService,
	InternalLinksService,
	$sce
) =>
	new AuthenticationService(
		$q,
		$http,
		$window,
		Utility,
		$timeout,
		$rootScope,
		LocalStorageService,
		InternalLinksService,
		$sce
	);
